import { tv, type VariantProps } from 'tailwind-variants'

import { dataFocusVisibleClasses } from '@/src/styles/classes'

export const listboxItemVariants = tv({
  slots: {
    base: [
      'flex',
      'flex-row',
      'items-center',
      'gap-4',
      'rounded-lg',
      'px-3',
      'hover:cursor-pointer',
      'w-full',
      'box-border',
      'subpixel-antialiased',
      'outline-none',
      'cursor-pointer',
      'tap-highlight-transparent',
      'web:transition-all web:duration-300 web:ease-in-out duration-300 ease-in-out',
      // focus ring
      ...dataFocusVisibleClasses,
    ],
    label: 'flex-1 self-center text-small truncate',
    icon: 'w-6 self-center items-center justify-center',
  },
  variants: {
    color: {
      default: {
        base: 'hover:bg-default-bg-medium',
        label: 'text-default-text-contrast-default',
        icon: 'text-default-text-contrast-default',
      },
      primary: {
        base: 'hover:bg-primary-bg-medium',
        label: 'text-primary-text-contrast-default',
        icon: 'text-primary-text-contrast-default',
      },
      danger: {
        base: 'hover:bg-danger-bg-medium',
        label: 'text-danger-text-contrast-default',
        icon: 'text-danger-text-contrast-default',
      },
    },
    isDisabled: {
      true: {
        base: 'opacity-disabled pointer-events-none',
      },
    },
    bold: {
      true: {
        base: 'py-4',
      },
      false: {
        base: 'py-3',
      },
    },
  },
  defaultVariants: {
    color: 'default',
    isDisabled: false,
    bold: false,
  },
})

export type TListboxItemVariantProps = VariantProps<typeof listboxItemVariants>
export type TListboxItemSlots = keyof ReturnType<typeof listboxItemVariants>
